import { render } from "./SearchUser.vue?vue&type=template&id=8871fe9e&scoped=true"
import script from "./SearchUser.vue?vue&type=script&lang=js"
export * from "./SearchUser.vue?vue&type=script&lang=js"

import "./SearchUser.vue?vue&type=style&index=0&id=8871fe9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8871fe9e"]])

export default __exports__